<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-container-padding-mobile backdrop-blur-sm md:p-container-padding-desktop"
  (click)="close.emit()"
>
  <div
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="alert-modal-message"
    class="glass-panel relative flex w-full max-w-sm flex-col items-center gap-bento-gap rounded-xl p-8 pt-12"
    (click)="$event.stopPropagation()"
  >
    <!-- Fechar -->
    <button
      type="button"
      aria-label="Fechar"
      class="active-press absolute right-3 top-3 flex h-10 w-10 items-center justify-center rounded-full text-on-surface-variant transition-colors duration-150 hover:bg-surface-variant hover:text-primary"
      (click)="close.emit()"
    >
      <span class="material-symbols-outlined">close</span>
    </button>

    <!-- Mensagem -->
    <p
      id="alert-modal-message"
      class="text-center font-headline-md text-headline-md text-on-surface"
    >
      {{ message() }}
    </p>

    <!-- Ação -->
    <button
      type="button"
      class="active-press w-full rounded-full bg-secondary-container py-3 font-headline-md text-headline-md text-on-secondary-fixed shadow-[0_0_15px_var(--color-secondary-container)] transition-transform duration-150 hover:scale-95"
      (click)="close.emit()"
    >
      Entendi!
    </button>
  </div>
</div>
